<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormEnvio" role="form" method="post" autocomplete="off" onSubmit="return false">

                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                    <label for="">Clave</label>
                                    <div class="input-group mb-3">
                                        <input type="text" @keyup.enter="getClientebyClave()" v-model="objCliente.Clave" class="form-control" placeholder="Buscar por Clave" :disabled="bndClientebyName">

                                        <button v-if="!bndClienteReady" @click="getClientebyClave()" class="btn btn-search btn-primary" type="button" id="button-addon2"><i class="fa fa-search"></i></button>

                                        <button v-if="bndClienteReady" @click="Limpiar()" class="btn btn-search btn-warning" type="button" id="button-addon2" :disabled="ObjEnvio.IdEnvio>0"><i class="fa fa-trash"></i></button>
                                    </div>
                                    <!-- <input :disabled="DisableCliente" type="text" class="form-control" v-model="Clave"/> -->

                                    <!-- <div class="col-sm-12 col-md-6">
                                        <br>
                                        <button :disabled="ObjEnvio.IdEnvio>0" class="btn btn-warning mr-1" type="button" title="Buscar Cliente" @click="BuscarCliente"><i class="fa fa-search"></i></button>
                                        <button :disabled="ObjEnvio.IdEnvio>0" @click="LimpiarCliente" class="btn btn-warning" type="button" title="Limpiar Cliente"><i class="fa fa-eraser"></i></button>
                                    </div> -->
                                    <CValidation v-if="errorvalidacion.IdCliente" :Mensaje="'*'+errorvalidacion.IdCliente[0]"/>
                                </div>

                                <div class="col-sm-12 col-md-3">
                                    <template v-if="bndClientebyKey">
                                        <label class="form-label" for="NombreCliente">*Cliente</label>
                                        <input type="text" v-model="objCliente.Nombre" class="form-control" id="NombreCliente" placeholder="" readonly />
                                    </template>
                                    <BuscadorCliente v-if="!bndClientebyKey" ref="buscadorCliente" :ptextLabel="'Buscar Cliente'"
                                        @input="getCliente()" v-model="objCliente.IdCliente">
                                        <CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*' + errorvalidacion.IdCliente[0]"/>
                                    </BuscadorCliente>

                                    <!-- <label for="">Cliente</label>
                                    <treeselect @input="BuscarCliente" :disabled="DisableCliente" :options="ListaClientes" :placeholder="'Busque un Cliente'" v-model="ObjEnvio.IdCliente"></treeselect>
                                    <CValidation v-if="errorvalidacion.IdCliente" :Mensaje="'*'+errorvalidacion.IdCliente[0]"/> -->
                                </div>

                                <div class="col-sm-12 col-md-3">
                                    <label for="">Paquetería</label>
                                    <select @change="AjustarNombrePaqueteria" class="form-select form-control-search" v-model="ObjEnvio.IdPaqueteria">
                                        <option value="">--Seleccionar--</option>
                                        <option v-for="(item,index) in ListaPaqueteria" :value="item.IdPaqueteria" :key="index">{{ item.Nombre }}</option>
                                    </select>
                                    <CValidation v-if="errorvalidacion.IdPaqueteria" :Mensaje="'*'+errorvalidacion.IdPaqueteria[0]"/>
                                </div>

                                <div class="col-sm-12 col-md-3">
                                    <label for="">Garantía de Entrega</label>
                                    <select @change="AjustarDiasEntrega();" class="form-select form-control-search" v-model="ObjEnvio.IdFechaGarantia">
                                        <option value="">--Seleccionar--</option>
                                        <option v-for="(item,index) in ListaGarantia" :value="item.IdFechaPaquete" :key="index">{{ item.Nombre }}</option>
                                    </select>
                                    <CValidation v-if="errorvalidacion.IdFechaGarantia" :Mensaje="'*'+errorvalidacion.IdFechaGarantia[0]"/>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-12 col-md-3">
                                    <label for="">Número de Paquete</label>
                                    <input readonly type="text" class="form-control" v-model="ObjEnvio.NumPaquete"/>
                                    <CValidation v-if="errorvalidacion.NumPaquete" :Mensaje="'*'+errorvalidacion.NumPaquete[0]"/>
                                </div>

                                <div class="col-sm-12 col-md-3">
                                    <label for=""># de Guía</label>
                                    <input type="text" class="form-control" v-model="ObjEnvio.Numero"/>
                                    <CValidation v-if="errorvalidacion.Numero" :Mensaje="'*'+errorvalidacion.Numero[0]"/>
                                </div>

                                <div class="col-sm-12 col-md-3">
                                    <label for="">Fecha de Envío</label>
                                    <Datepicker @input="AjustarFechaEntrega" v-model="ObjEnvio.FechaEnvio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                                    <CValidation v-if="errorvalidacion.FechaEnvio" :Mensaje="'*'+errorvalidacion.FechaEnvio[0]"/>
                                </div>

                                <div class="col-sm-12 col-md-3">
                                    <label for="">Fecha Posible de Entrega</label>
                                    <Datepicker v-model="ObjEnvio.FechaEntrega" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                                    <CValidation v-if="errorvalidacion.FechaEntrega" :Mensaje="'*'+errorvalidacion.FechaEntrega[0]"/>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-lg-12">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Pedido</th>
                                                    <th>Fecha</th>
                                                    <th>Cliente</th>
                                                    <th>Estatus</th>
                                                    <th class="text-center">
                                                        <button type="button" @click="AbrirModalPedidos" class="btn btn-warning">Agregar Concepto</button>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in ListaPedidos" :key="index">
                                                    <td>
                                                        {{ item.FolioPedido }}
                                                    </td>
                                                    <td>
                                                        {{ item.Fecha }}
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control" readonly v-model="item.Cliente"/>
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-purple" style="width: 150px !important">{{ item.Estatus }}</span>
                                                    </td>
                                                    <td>
                                                        <button v-show="item.ShowButtonDelete" @click="BorrarPedido(index)" class="btn btn-primary"><i class="fa fa-trash"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-lg-12">
                                    <label for="">Observaciones</label>
                                    <textarea v-model="ObjEnvio.Observaciones" class="form-control" rows="3"></textarea>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-12 text-end">
                                    <CBtnSave :poBtnSave="oBtnSave"></CBtnSave>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>

        <CModal :pConfigModal="ConfigModalPedidos" :poBtnSave="oBtnSavePedido">
            <template slot="Form">
                <FormPedido :poBtnSave="oBtnSavePedido" :pPedidosSeleccionados="ListaPedidos" :pIdCliente="ObjEnvio.IdCliente"></FormPedido>
            </template>
        </CModal>
    </div>
</template>
<script>
import Calendar from '@/helpers/StaticComboBox.js';
import Configs from '@/helpers/VarConfig.js';
import moment from 'moment';
import BuscadorCliente from '@/components/BuscadorCliente.vue';
import FormPedido from '../envios/ModalPedido.vue';
const EmitEjecuta='seccionEnvio';
const EmitEjecuta2='seccionPedido';

export default{
    name:'FormEnvio',
    props:['Obj','Id'],
    components:{
        FormPedido,
        BuscadorCliente,
    },
    data(){
        return{
            ConfigList:{
                Title:'Paquetería Formulario',
                IsModal:false,
                BtnReturnShow:true,
                BtnNewShow:false,
                ShowFiltros:false,
                ShowPaginador:false,
                TypeBody:'Form',
                EmitSeccion:EmitEjecuta
            },
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:false
            },
            oBtnSave:{
                Toast:0,
                IsModal:false,
                DisableBtn:false,
                ReturnRoute:'envios',
                EmitSeccion:EmitEjecuta
            },
            ConfigModalPedidos:{
                ModalTitle:"Lsitado de Pedidos",
                ModalNameId:"ModalFormPedidos",
                EmitSeccion:EmitEjecuta2,
                ModalSize:"xl",
                ShowFooter:false
            },
            oBtnSavePedido:{
                Toast:0,
                IsModal:true,
                DisableBtn:false,
                EmitSeccion:EmitEjecuta2
            },
            ObjEnvio:{
                IdEnvio:0,
                IdCliente:null,
                IdUsuario:0,
                IdPaqueteria:'',
                IdFechaGarantia:'',
                Numero:'',
                Paqueteria:'',
                NumPaquete:'1',
                FechaEnvio:'',
                FechaEntrega:'',
                Observaciones:''
            },
            segurity:{},
            Emit: EmitEjecuta,
            errorvalidacion: [],
            Setpicker: Calendar.calendarSettings,
            Clave: '',
            Cliente: '',
            ListaClientes: [],
            ListaPaqueteria: [],
            ListaGarantia: [],
            ListaPedidos: [],
            DiasEntrega: 1,
            DisableCliente:false,
            objCliente: {
            },
            showAlertCliente: false,
			bndClienteReady: false,
			bndClientebyKey: false,
			bndClientebyName: false,
        }
    },
    methods:{
        Guardar()
        {
            if (this.ListaPedidos.length>0)
            {
                this.oBtnSave.DisableBtn = true;
                let FechaEnvio = '';
                let FechaEntrega = '';

                if (this.ObjEnvio.FechaEnvio!='') {
                    FechaEnvio=moment(this.ObjEnvio.FechaEnvio).format('YYYY-MM-DD');
                }
                if (this.ObjEnvio.FechaEntrega!='') {
                    FechaEntrega=moment(this.ObjEnvio.FechaEntrega).format('YYYY-MM-DD');
                }

                let formData=new FormData();
                formData.set('IdCliente',this.ObjEnvio.IdCliente);
                formData.set('IdPaqueteria',this.ObjEnvio.IdPaqueteria);
                formData.set('IdFechaGarantia',this.ObjEnvio.IdFechaGarantia);
                formData.set('Numero',this.ObjEnvio.Numero);
                formData.set('Paqueteria',this.ObjEnvio.Paqueteria);
                formData.set('NumPaquete',this.ObjEnvio.NumPaquete);
                formData.set('IdPaqueteria',this.ObjEnvio.IdPaqueteria);
                formData.set('FechaEnvio',FechaEnvio);
                formData.set('FechaEntrega',FechaEntrega);
                formData.set('Observaciones',this.ObjEnvio.Observaciones);
                formData.set('DetalleEnvio',JSON.stringify(this.ListaPedidos));

                if (this.ObjEnvio.IdEnvio==0)
                {
                    this.$http.post('envio',
                        formData
                    ).then((res)=>{
                        this.EjecutaConExito(res)
                    }).catch((err)=>{
                        this.EjecutaConError(err);
                    });   
                }
                else{
                    this.$http.post('envio/'+this.ObjEnvio.IdEnvio,
                        formData
                    ).then((res)=>{
                        this.EjecutaConExito(res)
                    }).catch((err)=>{
                        this.EjecutaConError(err);
                    });
                }
            }
            else{
                this.$toast.warning('Debe Ingresar al Menos un Pedido');
            }
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn=false;
            this.bus.$emit('RunAlerts_'+this.Emit);
            this.Regresar();
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn=false;
            this.errorvalidacion=err.response.data.errors;
            this.oBtnSave.Toast=2;
        },
        Recuperar()
        {
            this.$http.get('envio/'+this.ObjEnvio.IdEnvio
            ).then((res)=>{
                this.ObjEnvio = res.data.data.envio;

                let FormatedDateEnvio = this.ObjEnvio.FechaEnvio.replace(/-/g,'\/');
                this.ObjEnvio.FechaEnvio = new Date(FormatedDateEnvio);
                let FormatedDateEntrega = this.ObjEnvio.FechaEntrega.replace(/-/g,'\/');
                this.ObjEnvio.FechaEntrega = new Date(FormatedDateEntrega);

                res.data.data.detallesenvio.forEach(element => {
                    element.ShowButtonDelete=false;
                });

                this.ListaPedidos = res.data.data.detallesenvio;
                this.objCliente.Clave = this.ObjEnvio.Clave;
                this.objCliente.IdCliente = this.ObjEnvio.IdCliente;
                this.objCliente.Nombre = this.ObjEnvio.Cliente;
                this.bndClientebyKey = true;
                this.bndClienteReady = true;
                this.bndClientebyName = true;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Regresar(){
            this.$router.push({name:'envios'});
        },
        Limpiar()
        {
            this.ObjEnvio = {
                IdEnvio: 0,
                IdCliente: 0,
                IdUsuario: 0,
                IdPaqueteria: '',
                IdFechaGarantia: '',
                Numero: '',
                Paqueteria: '',
                NumPaquete: '1',
                FechaEnvio: '',
                FechaEntrega: '',
                Observaciones: ''
            };

            this.errorvalidacion = [];
            this.SetearFechas();
			this.limpiaCliente();
            this.ListaPedidos = [];

        },
        async GetListaPaqueteria(){
            await this.$http.get('paqueteriasSimple').then((res)=>{
                this.ListaPaqueteria = res.data.data;
            });
        },
        async GetListaGarantia(){
            await this.$http.get('fechaspaquetesSimple').then((res)=>{
                this.ListaGarantia = res.data.data;
            });
        },

        /*
        async GetListaClientes(){
            await this.$http.get('enviocliente').then((res)=>{
                this.ListaClientes = res.data.data.map((Element)=>{
                    return{
                        id: Element.IdCliente,
                        label: Element.Nombre
                    }
                });
            });
        },
        async BuscarCliente()
        {
            if ((this.Clave!='' || this.ObjEnvio.IdCliente!=null) && !this.DisableCliente) {
                await this.$http.get('envioclavecliente',{
                    params:{
                        Clave:this.Clave,
                        IdCliente:this.ObjEnvio.IdCliente
                    }
                }).then((res)=>{
                    res.data.data.pedidos.forEach(element => {
                       element.ShowButtonDelete=true; 
                    });
                    this.ListaPedidos=res.data.data.pedidos;
                    this.ObjEnvio.IdCliente=res.data.data.cliente.IdCliente;
                    this.ObjEnvio.IdPaqueteria=res.data.data.cliente.IdPaqueteria;
                    this.Clave=res.data.data.cliente.Clave;
                    this.DisableCliente=true;
                    // console.log(res.data.data);
                }).catch((err)=>{
                    this.$toast.warning(err.response.data.message);
                });   
            }
        },
        LimpiarClientes()
        {
            this.DisableCliente=false;
            this.Clave='';
            this.ObjEnvio.IdCliente=null;
            this.ListaPedidos=[];
        },
        */

        getCliente()
		{    
            this.$http.get(`/clientes/${this.objCliente.IdCliente}` )
            .then( res => {
                const cliente = res.data.data;
                this.objCliente = cliente;
				this.ObjEnvio.IdCliente = this.objCliente.IdCliente;
				this.bndClienteReady = true;
                this.bndClientebyName = true;

            }).catch( err => {
            	this.limpiaCliente();
            });
        },
        getClientebyClave()
		{
            // console.log('executando cliente')
            // console.log(this.objCliente.Clave)
			if(this.objCliente.Clave != '')
			{
				this.$http.get('envioclavecliente',{
                    params:{
                        Clave: this.objCliente.Clave,
                        IdCliente: this.ObjEnvio.IdCliente
                    }
            }).then( res => {
                    res.data.pedidos.forEach(element => {
                       element.ShowButtonDelete=true; 
                    });

                    this.ListaPedidos = res.data.pedidos;

					const cliente = res.data.data;
					//this.$refs.buscadorCliente.setArrClientes(cliente);
					this.objCliente = cliente;
					this.ObjEnvio.IdCliente = cliente.IdCliente
					this.ObjEnvio.IdPaqueteria = cliente.IdPaqueteria
					this.bndClientebyKey = true;
					this.bndClienteReady = true;
                    this.AjustarNombrePaqueteria();

				}).catch( err => {
					this.$toast.warning('Cliente no encontrado');
					this.limpiaCliente();
					
				}).finally(() => {
				});
			}
            else{
                this.$toast.warning('Ingrese una Clave');
            }
        },
    	setCliente( cliente = {} )
		{
			// console.log('SettingCliente');
        	const buscadorCliente = this.$refs.buscadorCliente;
            buscadorCliente.clientes.push({
                label: `${cliente.Nombre}`,
                detalle: {
                    clave: cliente.Clave,
					Rfc: cliente.Rfc,
                },
				key: cliente.IdCliente,
        	});
        },
		limpiaCliente()
		{
            this.objCliente = {
                IdCliente: '',
                Clave: '',
                NombreComercial: '',
                RazonSocial: '',
                Rfc: '',
                Contacto: '',
                Telefono: '',
                Correo: '',
                Direccion:'',
                Calle: '',
                NoInt: '',
                NoExt: '',
                Colonia: '',
                Cp: '',
                Cruzamiento1: '',
                Cruzamiento2: '',
                Referencias: '',
                IdEstado: '',
                IdMunicipio: '',
            }

			this.bndClienteReady = false;
			this.bndClientebyKey = false;
			this.bndClientebyName = false;
        },

        AjustarNombrePaqueteria()
        {
            let IndexPaqueteria = this.ListaPaqueteria.findIndex((element)=>element.IdPaqueteria==this.ObjEnvio.IdPaqueteria);
            if (IndexPaqueteria!=-1) {
                this.ObjEnvio.Paqueteria = this.ListaPaqueteria[IndexPaqueteria].Nombre;
            }
        },  
        AjustarDiasEntrega()
        {
            let IndexDias = this.ListaGarantia.findIndex((element)=>element.IdFechaPaquete==this.ObjEnvio.IdFechaGarantia);
            if (IndexDias!=-1) {
                this.DiasEntrega = parseInt(this.ListaGarantia[IndexDias].Dias);   
            }
            else{
                this.DiasEntrega = 1;
            }
            this.AjustarFechaEntrega();
        },
        AjustarFechaEntrega()
        {
            let FechaEnvio = this.ObjEnvio.FechaEnvio;
            let FechaEntrega = new Date(FechaEnvio.getTime()+this.DiasEntrega*24*60*60*1000);
            this.ObjEnvio.FechaEntrega = FechaEntrega;
        },
        AbrirModalPedidos()
        {
            if (this.ObjEnvio.IdCliente > 0) {
                this.bus.$emit('NewModal_'+this.ConfigModalPedidos.EmitSeccion,0);   
            } else {
                this.$toast.warning('Debe Seleccionar un Cliente');
            }
        },
        SeleccionPedido(item){
            this.ListaPedidos.push(item);
        },
        BorrarPedido(index){
            this.ListaPedidos.splice(index,1);
        },
        SetearFechas(){
            let Hoy = new Date();
            this.ObjEnvio.FechaEnvio = Hoy;
            let Maniana = new Date();
            Maniana.setDate(Maniana.getDate()+1);
            this.ObjEnvio.FechaEntrega = Maniana;
        }
    },
    created(){
        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted(){
        this.bus.$off('SeleccionarPedido');
        this.bus.$on('SeleccionarPedido',(item)=>{
            this.SeleccionPedido(item);
        });

        
        this.Limpiar();
        // this.GetListaClientes();
        this.GetListaPaqueteria();
        this.GetListaGarantia();

        if (this.Id>0)
        {
            this.DisableCliente = true;
            this.ObjEnvio.IdEnvio = this.Id;
            this.Recuperar();
        }
        else{
            this.ConfigLoad.ShowLoader=false;
        }

        this.bus.$on('Save_'+this.Emit,()=>{
            this.Guardar();
        });
        this.bus.$on('EmitReturn',()=>{
            this.Regresar();
        });
    }
}
</script>